<div class="notification is-danger" *ngIf="showPhoneVerificationAlert" i18n>
  <div class="icon">
    <i class="far fa-times-circle fa-lg"></i>
  </div>
  Please add/verify your phone number below.
</div>

<form
  [formGroup]="form"
  (ngSubmit)="submit()"
  (keyup.Tab)="onTabKeyNavigation()"
  (keyup.shift.tab)="onTabKeyNavigation()"
>
  <div>
    <div class="box is-clipped">
      <h2 class="title is-3" i18n>General details</h2>

      <label class="field" *ngIf="!isUserNameToCreate && !this.isNamewithNewConfig">
        <div class="label" i18n>Full name</div>
        <div class="control">
          <input
            #fullNameInput
            class="input"
            [formControl]="name"
            data-e2e="input-full-name"
            type="text"
            [ngClass]="{ 'is-danger': isInvalid(name) }"
          />
          <portal-form-error [formInput]="name" errorId="name"></portal-form-error>
        </div>
        <ng-container *ngIf="!isNamewithNewConfig">
          <div class="has-text-grey-darker is-size-7 pl-1">
            <span *ngIf="!isUserNameToUpdate" i18n
              >The full name is now created by using the first, middle, and last name for each
              user.</span
            >
            <span *ngIf="isUserNameToUpdate" i18n
              >The full name will not be displayed once you save the user with the new
              configuration.</span
            >
          </div>
          <div class="is-size-7 pl-1">
            <a
              (click)="setIsUserNameToUpdate()"
              *ngIf="!isUserNameToUpdate && !isPetroUser"
              i18n
              title="Update user name"
              i18n-title
              >Click here if you want to update the user's name.</a
            >
          </div>
        </ng-container>
      </label>

      <ng-container *ngIf="isUserNameToUpdate || isUserNameToCreate">
        <label class="field">
          <div class="label" i18n>First name</div>
          <div class="control">
            <input
              #firstNameInput
              class="input"
              [formControl]="firstName"
              data-e2e="input-first-name"
              type="text"
              [ngClass]="{ 'is-danger': isInvalid(firstName) }"
            />
            <portal-form-error [formInput]="firstName" errorId="firstName"></portal-form-error>
          </div>
        </label>

        <label class="field">
          <div class="label">
            <span i18n> Middle name </span>
            <span>
              &nbsp;&nbsp;<span class="has-text-grey-darker has-text-weight-normal" i18n>(Optional)</span>
            </span>
          </div>
          <div class="control">
            <input
              class="input"
              [formControl]="middleName"
              data-e2e="input-middle-name"
              type="text"
              [ngClass]="{ 'is-danger': isInvalid(middleName) }"
            />
            <portal-form-error [formInput]="middleName" errorId="middleName"></portal-form-error>
          </div>
        </label>

        <label class="field">
          <div class="label">
            <span i18n>Last name</span>
            <span>
              &nbsp;&nbsp;<span class="has-text-grey-darker has-text-weight-normal" i18n>(Optional)</span>
            </span>
          </div>
          <div class="control">
            <input
              class="input"
              [formControl]="lastName"
              data-e2e="input-last-name"
              type="text"
              [ngClass]="{ 'is-danger': isInvalid(lastName) }"
            />
            <portal-form-error [formInput]="lastName" errorId="lastName"></portal-form-error>
          </div>
        </label>
      </ng-container>

      <label class="field">
        <div class="label" i18n>Email</div>
        <div class="control">
          <input
            class="input"
            [formControl]="email"
            data-e2e="input-email"
            type="text"
            [ngClass]="{ 'is-danger': isInvalid(email) }"
          />
          <portal-form-error [formInput]="email" errorId="email"></portal-form-error>
        </div>
      </label>

      <ng-container *ngIf="showSendResetPasswordEmailButton">
        <button
          *restrictPermission="['reset-password']"
          type="button"
          class="field button is-primary is-outlined"
          [disabled]="disabled"
          (click)="resetPasswordModal.open()"
          data-e2e="button-reset-password"
          i18n
          title="Send reset password email"
          i18n-title
        >
          Send reset password email
        </button>
      </ng-container>

      <label class="field" *ngIf="!loadingDefaultCountry">
        <div class="label" i18n>
          Phone Number
          <span class="has-text-grey-darker has-text-weight-normal">(Optional)</span>
        </div>
        <div class="columns" [ngClass]="{ 'mb-0': showPhoneNumberVerificationInfo }">
          <div
            class="control column"
            [ngClass]="{ 'is-two-thirds': selfEditMode, 'pb-0': showPhoneNumberVerificationInfo }"
          >
            <portal-int-tel-input
              [formControl]="phoneNumberControl"
              [class.is-danger]="isInvalid(phoneNumberControl)"
              [defaultCountryCode]="defaultCountryCode"
              [disabled]="
                !showVerifyPhoneNumberBtn && isPetroUser ? true : isPetroUser && !isPetroSiteAdmin
              "
            ></portal-int-tel-input>
          </div>
          <div
            class="column is-one-third"
            *ngIf="selfEditMode && showVerifyPhoneNumberBtn"
            [ngClass]="{ 'pb-0': showPhoneNumberVerificationInfo }"
          >
            <button
              type="button"
              class="button is-primary is-outlined"
              [ngClass]="{ 'is-loading': isVerifyPhoneNumberButtonLoading }"
              data-e2e="button-verify-phone-number"
              (click)="verifyPhoneNumber()"
              [disabled]="isVerifyPhoneNumberButtonDisabled"
              i18n
              title="Verify Phone Number"
              i18n-title
            >
              Verify Phone Number
            </button>
          </div>
        </div>
        <div *ngIf="showPhoneNumberVerificationInfo" class="help is-danger">
          <p data-e2e="info-phone-number-verification">
            Please verify phone number to save the changes or remove the phone number.
          </p>
        </div>
      </label>

      <ng-container *ngIf="showMarketingTermsAndConditions">
        <label class="checkbox field">
          <input
            [formControl]="marketingTermsAndConditionsFormControl"
            type="checkbox"
            data-e2e="checkbox-terms-and-conditions"
            (click)="updateHasFormChanged()"
          />
          <span class="is-size-7 has-text-word-break" i18n>
            I agree that Verifone and its affiliates may text or call me about Petro solutions
            services and related offers, including using an autodialer or prerecorded voice. Msg &
            data rates may apply. Frequency varies. Reply STOP (or similar) to opt out, HELP for
            help. Consent is not a condition of purchase. See our Privacy Policy
            (https://www.verifone.com/en/global/legal/privacy-policy) for more details.
          </span>
        </label>
      </ng-container>

      <div class="field" data-e2e="field-locale" *ngIf="canSwitchLanguage">
        <div class="label" i18n>Interface language</div>
        <portal-filter-language
          [languages]="languagesList"
          [label]="selectedLanguage?.name"
          [selectedLanguage]="selectedLanguage"
          [hideApplyButton]="hideApplyButton"
          [isLanguageButtonFocused]="isLanguageButtonFocused"
          (languageSelected)="onSelectLanguage($event)"
        ></portal-filter-language>
      </div>

      <div data-e2e="default-application" *ngIf="selfEditMode && apps.length > 1">
        <portal-select-control
          name="Default Application"
          [control]="defaultApplication"
          [invalid]="isInvalid(defaultApplication)"
          [options]="appList"
          [e2eName]="'select-application'"
          [e2eErrorName]="'select-application-error'"
          class="field"
          i18n-name
        ></portal-select-control>
      </div>

      <div class="box__separator"></div>

      <h2 class="title is-3" i18n>Access rights</h2>

      <label class="field">
        <div *ngIf="isPetroUser" class="label" i18n>Organization</div>
        <div *ngIf="!isPetroUser" class="label" i18n>Organisation</div>
        <ng-container *ngIf="isOrganisationReadonly; else organisationSelect">
          <div class="box has-background-white-bis is-shadowless is-borderless p-2">
            <span
              class="button is-static has-background-info-lighter has-text-grey-darker is-borderless"
              data-e2e="organisation-readonly"
              >{{ organisationReadonlyName }}</span
            >
          </div>
        </ng-container>
        <ng-template #organisationSelect>
          <portal-hierarchy-single-select
            [control]="entityUid"
            [isShowGroup]="true"
            data-e2e="user-hierarchy-select"
            (selectedOrganisation)="onOrganisationSelected($event)"
          ></portal-hierarchy-single-select>
        </ng-template>
        <portal-form-error [formInput]="entityUid" errorId="entityUid"></portal-form-error>
      </label>

      <div class="has-margin-top-2x" *ngIf="!this.selfEditMode && loggedInUser">
        <ng-container *ngIf="disableRolePicker; else fullRolePicker">
          <div class="field">
            <div class="label" i18n>Acquirer</div>
            <div class="control mt-3">
              <label class="checkbox" data-e2e="checkbox-ACQUIRER_USER-label">
                <input type="checkbox" data-e2e="checkbox-ACQUIRER_USER" checked disabled />
                <span i18n>Acquirer User</span>
              </label>
            </div>
          </div>
        </ng-container>
        <ng-template #fullRolePicker>
          <portal-role-group-picker
            [user]="user"
            [loggedInUser]="loggedInUser"
            [disabled]="disabled"
            [allRoleGroups]="editableRoles"
            [isVerifoneEmail]="isVerifoneEmail"
            (selectedRoles)="onSetRoles($event)"
            data-e2e="user-role-picker"
          ></portal-role-group-picker>
        </ng-template>
        <portal-form-error [formInput]="roles" errorId="roles"></portal-form-error>
      </div>

      <ng-container *ngIf="toShowDeveloperNotificationSettings()">
        <div class="box__separator"></div>
        <h2 class="title is-3">Email Notifications Setting</h2>
        <div class="field">
          <div class="toggle">
            <input
              id="user-app-notification-setting"
              type="checkbox"
              [checked]="notificationUpdateStatus"
              (change)="onNotificationUpdate($event)"
              data-e2e="user-app-notification-setting"
            />
            <label
              for="user-app-notification-setting"
              data-e2e="user-app-notification-setting-label"
              >Receive email notifications when app status changes</label
            >
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isMyProfile && !federationStatus">
        <ng-container *ngIf="resetPasswordFeatureActive; else redirectResetPassword">
          <div class="box__separator"></div>
          <h2 class="title is-3" i18n>Password</h2>
          <a
            class="button is-primary is-outlined"
            [routerLink]="['/administration', 'users', user?.userUid, 'edit', 'change-password']"
            data-e2e="change-password"
            i18n
            title="Change password"
            i18n-title
          >
            Change password
          </a>
        </ng-container>

        <ng-template #redirectResetPassword>
          <div class="box__separator"></div>
          <h2 class="title is-3" i18n>Change password</h2>
          <p class="label has-text-weight-normal" i18n>
            You will be redirected to a secure page to change your password.
          </p>
          <button
            type="button"
            class="button"
            (click)="changePasswordModal.open()"
            data-e2e="button-change-password"
            i18n
            title="Change password"
            i18n-title
          >
            Change password
          </button>
        </ng-template>
      </ng-container>
    </div>
    <div class="columns is-vcentered is-mobile is-flex is-flex-wrap-wrap">
      <div class="column">
        <ng-container *ngIf="!user">
          <button
            class="button has-text-danger is-text"
            data-e2e="link-cancel"
            restrict-permission
            [routerLink]="['/administration', 'users']"
            i18n
            title="discard changes"
            type="button"
            i18n-title
          >
            Discard changes
          </button>
        </ng-container>
        <ng-container *ngIf="user">
          <button
            class="button has-text-danger is-text"
            data-e2e="link-cancel"
            restrict-permission
            [routerLink]="['/administration', 'users', user?.userUid]"
            i18n
            title="Discard changes"
            type="button"
            i18n-title
          >
            Discard changes
          </button>
        </ng-container>
      </div>
      <div class="column is-narrow">
        <button
          type="submit"
          class="button is-primary"
          [class.is-loading]="saving"
          data-e2e="button-submit"
          (click)="checkFirstName()"
          [disabled]="!canSaveUser || saving"
          title="Save"
          i18n-title
        >
          <span *ngIf="!user" i18n>Save</span>
          <span *ngIf="user" i18n #saveChangesText>Save changes</span>
        </button>
      </div>
    </div>
  </div>
</form>

<portal-base-modal #resetPasswordModal>
  <div title i18n>Reset password</div>
  <div description i18n>
    The user will receive an email and it will be redirected to a secure page to change his
    password.
  </div>
  <div class="level" buttons>
    <div class="level-left"></div>
    <div class="buttons">
      <button
        class="button"
        data-e2e="cancel-reset-password-button"
        (click)="resetPasswordModal.close()"
        i18n
        title="Cancel"
        i18n-title
      >
        Cancel
      </button>
      <button
        type="button"
        class="button is-primary"
        (click)="onResetPasswordModalConfirmed()"
        data-e2e="confirm-reset-password-button"
        i18n
        title="Confirm"
        i18n-title
      >
        Confirm
      </button>
    </div>
  </div>
</portal-base-modal>
<portal-base-modal #changePasswordModal>
  <div title i18n>Redirect notice</div>
  <div description i18n>
    You will be redirected to a secure page to change your password. Make sure to save changes
    before continuing.
  </div>
  <div class="level" buttons>
    <div class="level-left"></div>
    <div class="buttons">
      <button
        class="button"
        data-e2e="cancel-change-password-button"
        (click)="changePasswordModal.close()"
        i18n
        title="Cancel"
        i18n-title
      >
        Cancel
      </button>
      <button
        type="button"
        class="button is-primary"
        (click)="onChangePasswordModalConfirmed()"
        data-e2e="confirm-change-password-button"
        i18n
        title="Confirm"
        i18n-title
      >
        Confirm
      </button>
    </div>
  </div>
</portal-base-modal>
<portal-base-modal [width]="(isDeviceMobile$ | async) ? null : '428px'" #verifyPhoneNumberModal>
  <div title i18n>Validate Phone Number</div>
  <div description>
    <p class="pb-3" i18n>
      A One-Time Passcode (OTP) has been sent to your registered phone number. Please enter the OTP
      below to verify.
    </p>
    <label class="field">
      <div class="label" i18n>One-Time Passcode</div>
      <div class="control">
        <input
          class="input"
          [formControl]="otpFormControl"
          data-e2e="input-phone-verification-otp"
          type="text"
          [ngClass]="{ 'is-danger': isInvalid(otpFormControl) }"
        />
      </div>
    </label>
    <div *ngIf="isInvalidOtpError" class="help is-danger mb-3">
      <p data-e2e="error-Otp">
        {{ otpErrorMessage || OtpErrorMessage.incorrectOtpAlertMessage }}
      </p>
    </div>

    <!-- Note below OTP field - always shown for attempts 1-4 -->
    <div class="has-text-grey is-size-7 my-4">
      <p *ngIf="!hasExceededMaxResends" i18n>Note: This code expires in 15 minutes.  If you didn't receive the code, please wait a few minutes or request a new one.</p>
    </div>
  </div>
  <div class="is-flex is-justify-content-space-between is-flex-wrap-wrap" buttons>
    <div>
      <button class="button is-text has-text-primary" (click)="verifyPhoneNumberModal.close()" i18n>
        Back
      </button>
    </div>
    <div class="buttons">
      <button
        *ngIf="isWSO2Enabled; else resendOtpButton"
        class="button is-primary is-outlined"
        [ngClass]="{ 'is-loading': isResendOtpLoading }"
        (click)="resendOtp()"
        [disabled]="resendCountdown > 0 || isResendOtpLoading"
        data-e2e="request-new-otp-button"
        title="Request New OTP"
        i18n-title
        i18n
      >
        Request New OTP<span *ngIf="resendCountdown > 0 && !hasExceededMaxResends">&nbsp;({{ resendCountdown }}s)</span>
      </button>

      <ng-template #resendOtpButton>
        <button
          class="button is-primary is-outlined"
          [ngClass]="{ 'is-loading': isResendOtpLoading }"
          (click)="resendOtp()"
          [disabled]="isResendOtpLoading"
          data-e2e="request-new-otp-button"
          title="Resend OTP"
          i18n-title
          i18n
        >
          Resend OTP
        </button>
      </ng-template>
      <button
        type="button"
        class="button is-primary"
        [ngClass]="{ 'is-loading': isPhoneNumberOtpLoading }"
        (click)="verifyOtp()"
        [disabled]="isOtpSubmitButtonEnabled"
        data-e2e="confirm-change-password-button"
        i18n
        title="Submit"
        i18n-title
      >
        Submit
      </button>
    </div>
  </div>
  <!-- Error message for max resend attempts -->
  <div *ngIf="hasExceededMaxResends" class="has-text-grey is-size-7 mt-3" buttons>
    <p i18n>You've requested too many OTPs. You can request a new code in {{ formatCountdown(resendCountdown) }} min</p>
  </div>
</portal-base-modal>
